(function($) {
  
	function custom_mailchimp_subscribe() {
		var success = true;	
		if($('#custom-create-input').prop('checked')) {
			$('#custom-go-group input[type="checkbox"]').attr('checked', true);
            $('#custom-go-group input[type="checkbox"]').prop('checked', true);
			var showcustomeremail = $('#create_customer input[name="customer[email]"]').val();
			if (showcustomeremail != '') {
				$('#custom-go-group input#mce-EMAIL').val(showcustomeremail);
			}
			success = true;       
		}
		else {
			$('#custom-go-group input[type="checkbox"]').attr('checked', false);
             $('#custom-go-group input[type="checkbox"]').prop('checked', false);
			$('#custom-go-group input#mce-EMAIL').val('');
			success = false;
		}
		return success; 
	}

	$(document).on('click', '#custom-create-input', function(){
      
		custom_mailchimp_subscribe();
	});
	$(document).on('click', '#create_customer input[type="submit"]', function(e){
      
		if(custom_mailchimp_subscribe() == true)
		{
			e.preventDefault();
			setTimeout(function(){
				document.getElementById('create_customer').submit();
			}, 2000);
		}
		$('div#custom-go-group input#mc-embedded-subscribe').click();
	});
  
    $(document).ready(function ($) {
      var cookiebar = setInterval(function(){
        if($("body").length > 0){
          if($('#accept-cookies').is(':visible')){
              $("body").addClass("show-cookie-bar");
          }
        else {
          $("body").removeClass("show-cookie-bar");
        }
      }
      });
     });
  
  $(document).ready(function($){
      
 

    
    
      
  	var activeparent = setInterval(function(){
        if($(".view-mode").length > 0){
          if($('.view-mode .view-as .icon-mode').hasClass('active')){
              $('.view-mode .view-as .icon-mode.active').parent().addClass("active-parent");
          }
        else {
          
        }
      }
      });
        $(document).on('click', '.view-mode .view-as', function(e){
			e.preventDefault();
          	
          var self = $(this),
                    parents = self.closest('[data-view-as]');
          
          if (!self.hasClass('active')) {
            parents.find('.view-as').removeClass('active-parent');
            self.find('.view-as').addClass('active-parent');
          };
          
        });
    
    	var slidequnty = setInterval(function(){
      
        if($('.template-product .product-img-box .slider-nav .slick-track > .item').length > 0 ) {
          $('.template-product .product-img-box .slider-nav .slick-track > .item').parent().parent().parent().parent().hide();
          $('.template-product .vertical-moreview').addClass('adjust-width');
        }
        });
    
    let get_solde = setInterval(function(){
      let get_solde_text = $("#solde").text();
    
      let compare_solde_text = '0.00';
      if(get_solde_text == compare_solde_text){
      	clearInterval(get_solde);
        $("#solde").parent().parent().addClass("no-balance");
      }
      else{
      	$("#solde").parent().parent().removeClass("no-balance");
      }
    });
    
   	 var get_shipping_add_text = $('.shipping-address-order-page > p').text();
      
      if(get_shipping_add_text == 0 ) {
      	$('.shipping-address-order-page').addClass("hide");
      }
      
      var get_billing_add_text = $('.billing-address-order-page > p').text();
      
      if(get_billing_add_text == 0 ) {
      	$('.billing-address-order-page').addClass("hide");
      }
      
      var telephone_number = $(".billing-address-order-page > p span.mt-10").text();
      
      if((telephone_number).length > 0 ) {
      	$('.template-customers-order .grid-item span.mt-10').addClass("telphone-before");
      }
    
   
  });
  
  
  
    var relted_pro = setInterval(function(){
      if(jQuery('#shopify-section-product-related-cheque-cadeau-gifties-custom .tab-content.active').length > 0){
        clearInterval(relted_pro);
        jQuery(".product-widget-tab").remove();
      }
    });
    

  
})(jQuery);

    


